import moment from "moment";
import * as range from "moment-range";
import { DateUtils } from "~app/common/utils/date-utils";

export const momentRange = range.extendMoment(moment as any);

export class Operation {

    get fullDayDuration() {
        return moment(this.endDate).diff(moment(this.startDate), "d", false);
    }

    constructor(
        public arbetsorderId: number,
        public operationId: number,
        public startDate: Date,
        public endDate: Date,
        public workdayOffset: number,
        private readonly helgdagCalculator: (date: string | moment.Moment) => boolean) {
    }

    shiftDays(daysShifted: number) {
        const oldEndDate = moment(this.endDate);
        const oldWorkdays = this.workdaysUntil(oldEndDate);
        this.startDate = moment(this.startDate).add(daysShifted, "d").toDate();
        this.endDate = moment(this.endDate).add(daysShifted, "d").toDate();
        let newWorkdays = this.workdaysUntil(moment(this.endDate));
        while (newWorkdays !== oldWorkdays) {
            this.endDate = moment(this.endDate).add(oldWorkdays - newWorkdays, "d").toDate();
            newWorkdays = this.workdaysUntil(moment(this.endDate));
        }
    }

    setStartingDate(date: moment.Moment) {
        const diff = DateUtils.daysBetween(date, moment(this.startDate));
        this.shiftDays(diff);
    }

    workdaysUntil(date: moment.Moment) {
        const daysBetween = DateUtils.daysBetween(date, moment(this.startDate));
        const holidays = DateUtils.countDaysOfType(moment(this.startDate), moment(date), this.helgdagCalculator);
        return daysBetween - holidays;
    }

    weekendDuration() {
        const rangeBefore = momentRange.range(moment(this.startDate), moment(this.endDate));
        return DateUtils.countDaysOfType(rangeBefore.start, rangeBefore.end, this.helgdagCalculator);
    }
}
